<template>
  <v-alert v-if="closed" type="info" text dense :class="alertClass">{{ $modules.message(module) }}</v-alert>
</template>

<script>
// Aviso exibido quando o módulo está fechado em Módulos e prazos (backoffice), com a mensagem configurada.
export default {
  name: "ModuleClosedAlert",
  props: {
    module: { type: String, required: true },
    alertClass: { type: String, default: "mt-2" },
  },
  computed: {
    closed() { return this.$modules.state.loaded && !this.$modules.isOpen(this.module); },
  },
};
</script>
